import { Texture2D, _decorator } from 'cc';
import TintParticle from '../Shader/TintParticle';
import MultiThemeTintObject from './MultiThemeTintObject';

const { ccclass, property } = _decorator;

@ccclass('MultiThemeTintParticle')
export default class MultiThemeTintParticle extends MultiThemeTintObject {
    @property
    protected readonly updateTextures = true;

    @property({
        type: [Texture2D],
        visible(this: MultiThemeTintParticle) {
            return this.updateTextures;
        },
    })
    protected readonly textures: Texture2D[] = [];

    public getMaxTheme(): number {
        if (this.updateTextures) {
            return this.textures.length;
        }
        return super.getMaxTheme();
    }

    public resetInEditor() {
        if (this.target) {
            this.gradientSets.push(this.target.tintGradient);
        }
    }

    protected getTarget(): TintParticle {
        return this.getComponent(TintParticle);
    }

    protected onThemeChanged() {
        if (this.updateTextures && this.textures[this.theme]) {
            (this.target as TintParticle).mainTexture = this.textures[this.theme];
        }
        super.onThemeChanged();
    }
}
